import { render, staticRenderFns } from "./PressaoArterial.vue?vue&type=template&id=42992be8&"
import script from "./PressaoArterial.vue?vue&type=script&lang=js&"
export * from "./PressaoArterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports